import { render, staticRenderFns } from "./Emprestimos.vue?vue&type=template&id=4a393260&scoped=true&"
import script from "./Emprestimos.vue?vue&type=script&lang=js&"
export * from "./Emprestimos.vue?vue&type=script&lang=js&"
import style0 from "./Emprestimos.vue?vue&type=style&index=0&id=4a393260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a393260",
  null
  
)

export default component.exports